module.exports = __webpack_public_path__ + "static/img/sx.1903d7bc.png";